import { BootstrapGridBreakpoints } from '@gn-audio/ui/constants/bootstrap-grid-breakpoints';
import { Directive, Inject, Input, OnInit } from 'angular-ts-decorators';

import { element } from 'angular';

interface IProductReadMoreDirectiveScope extends ng.IScope {
  productId: string;
  productType: string;
  emptyText: string;
  onBulletsLoaded: () => void;
}

const defaultAnimateTiming = 400;

import expandTemplate from './product-read-more.template.expand.html';
import template from './product-read-more.template.html';

@Directive({
  restrict: 'E',
  selector: 'productReadMore',
  template,
})
export class ProductReadMoreDirective implements OnInit {
  public static $inject: ReadonlyArray<string> = ['$scope', '$element', '$compile', '$timeout'];

  @Input() public productId?: string;
  @Input() public productType?: string;
  @Input() public emptyText?: string;

  constructor(
    @Inject('$scope') private $scope: IProductReadMoreDirectiveScope,
    @Inject('$element') private $element: JQLite,
    @Inject('$compile') private $compile: ng.ICompileService,
    @Inject('$timeout') private $timeout: ng.ITimeoutService,
  ) { }

  public ngOnInit() {
    let mode: 'mobile' | 'desktop' = window.innerWidth < BootstrapGridBreakpoints.Medium ? 'mobile' : 'desktop';

    const $parent: JQuery = this.$element.parent();
    const $close: JQuery = $parent.find('.product-read-more__close');
    const $label: JQuery = this.$element.find('.product-read-more__label');
    const $slick: JQuery = $parent.find('slick');
    const $labels: JQuery = $parent.find('product-item-labels');
    const $calloutMessage: JQuery = $parent.find('callout-message');
    const $features: JQuery = $parent.find('.product-item-features__container');
    const $readMore: JQuery = this.$element.find('.product-read-more__label--collapsed');
    const $readLess: JQuery = this.$element.find('.product-read-more__label--expanded');

    const clickHandler: (eventObject: JQueryEventObject) => void = (eventObject: JQueryEventObject) => {
      const $bullets: JQuery = this.$element.find('product-bullets');
      const compiled: boolean = $bullets.length > 0;

      if (compiled) {
        $close.fadeToggle(defaultAnimateTiming);
        $features.slideToggle(defaultAnimateTiming);
        $bullets.slideToggle(defaultAnimateTiming);
        $readMore.toggle();
        $readLess.toggle();
        $labels.toggle();
        $calloutMessage.toggle();

        if (mode === 'desktop') {
          $slick.slideToggle(defaultAnimateTiming, () => { ($slick as any).slick('setPosition'); });
        }
      } else {
        this.$scope.productId = this.productId;
        this.$scope.productType = this.productType;
        this.$scope.emptyText = this.emptyText;
        const compiledElement: JQLite = this.$compile(expandTemplate)(this.$scope);
        this.$element.prepend(compiledElement);
      }

      eventObject.preventDefault();
    };

    const resizeHandler: (eventObject?: JQueryEventObject) => void = () => {
      const prevMode: 'mobile' | 'desktop' = mode;
      mode = window.innerWidth < BootstrapGridBreakpoints.Medium ? 'mobile' : 'desktop';

      if (prevMode !== mode) {
        cleanUp();
      }
    };

    const cleanUp: () => void = () => {
      const $bullets: JQuery = this.$element.find('product-bullets');

      $readMore.show();
      $readLess.hide();
      $labels.show();
      $calloutMessage.fadeIn();
      $close.fadeOut(defaultAnimateTiming);
      $bullets.slideUp(defaultAnimateTiming);
      $features.slideDown(defaultAnimateTiming);
      $slick.slideDown(defaultAnimateTiming, () => { ($slick as any).slick('setPosition'); });
    };

    this.$scope.onBulletsLoaded = () => {
      this.$timeout(
        () => {
          const $bullets: JQuery = this.$element.find('product-bullets');

          $readMore.hide();
          $readLess.show();
          $labels.hide();
          $calloutMessage.hide();
          $features.slideUp(defaultAnimateTiming);
          $bullets.slideDown(defaultAnimateTiming);
          if (mode === 'desktop') {
            $slick.slideUp(defaultAnimateTiming);
            $close.fadeIn(defaultAnimateTiming);
          }
        },
        0,
        false,
      );
    };

    $label.on('click', clickHandler);
    $close.on('click', clickHandler);
    element(window).on('resize', resizeHandler);
    resizeHandler();

    this.$scope.$on(
      '$destroy',
      () => {
        $label.off('click', clickHandler);
        $close.off('click', clickHandler);
        element(window).off('resize', resizeHandler);
      },
    );
  }
}
